import styled from "styled-components";
import { toRem } from "shared/helpers";

export const DevicesHeadWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${toRem(12)};
    padding: ${toRem(16)} 0;
`;

export const DevicesHeadRow = styled.div`
    display: flex;
    gap: ${toRem(12)};
    align-items: center;
    justify-content: space-between;
    @media (width < ${toRem(768)}) {
        gap: ${toRem(8)};
        flex-wrap: wrap;
    }

    .input, .input__field {
        min-width: 166px!important;
    }
`;

export const DevicesHeadLeft = styled.div`
    display: flex;
    gap: ${toRem(12)};
    align-items: center;
    @media (width < ${toRem(768)}) {
        width: 100%;
        justify-content: space-between;
    }
`;

export const InputContainer = styled.div`
    width: ${toRem(220)};
    @media (width < ${toRem(768)}) {
        width: 100%;
    }
    
    .dropdown {
        width: 100%
    }
`;

